import { ECommerce } from "../Product/ECommerce/eCommerce";
import { BrandLogo } from "./components/brandLogo/brandLogo.container";
import { ProductPageProductBundlesContainer } from "./components/bundles/bundles.container";
import { ProductPageImageViewerContainer } from "./components/imageViewer/imageViewer.container";
import { InfoCard } from "./components/infoCard/infoCard.component";
import { ProductPageKeyFeaturesContainer } from "./components/keyFeatures/keyFeatures.container";
import { ProductPageFacingContainer } from "./components/productFacing/productFacing.container";
import { ProductInfo } from "./components/productInfo/productInfo.component";
import { PromoBanner } from "./components/promobanner/promoBanner.component";
import { Promotions } from "./components/promotions/promotions.component";
import { RecentlyViewedProductSliderContainer } from "./components/recentlyViewProductsSlider/recentlyViewProductsSlider.container";
import { RecommendProductsSliderContainer } from "./components/recommendProductsSlider/recommendProductsSlider.container";
import { ProductPageRecoverabilityIndexContainer } from "./components/recoverabilityIndex/recoverabilityIndex.container";
import { RelatedProductsSlider } from "./components/relatedProductsSlider/relatedProductsSlider.container";
import { Review } from "./components/review/review";
import { ProductDetailTitleBase } from "./components/title/productDetailTitle.component";
import { RatingSummaryContainer } from "./components/title/ratingSummary/ratingSummary.container";
import { Usps } from "./components/usps/usps";
import { Base } from "./productPage.base";
import { ProductPageProviders } from "./productPage.providers";

const ProductDetailTitle = Object.assign(ProductDetailTitleBase, {
    RatingSummary: RatingSummaryContainer
});

export const ProductPage = Object.assign(Base, {
    BrandLogo: BrandLogo,
    ECommerce: ECommerce,
    ImageViewer: ProductPageImageViewerContainer,
    InfoCard: InfoCard,
    KeyFeatures: ProductPageKeyFeaturesContainer,
    ProductBundles: ProductPageProductBundlesContainer,
    ProductFacing: ProductPageFacingContainer,
    ProductInfo: ProductInfo,
    PromoBanner: PromoBanner,
    Promotions: Promotions,
    Providers: ProductPageProviders,
    Usps: Usps,
    RecoverabilityIndex: ProductPageRecoverabilityIndexContainer,
    Review: Review,
    Title: ProductDetailTitle,
    RecommendProductsSlider: RecommendProductsSliderContainer,
    RelatedProductsSlider: RelatedProductsSlider,
    RecentlyViewedProductSlider: RecentlyViewedProductSliderContainer
});
